module.exports = __webpack_public_path__ + "img/HHbemleklap2025.75d87d68.jpg";